export enum WhoPaysType {
  Client = 0,
  Financing = 1,
  Other = 2,
}

export const whoPaysTypeValues: { [id: number]: string } = {
  0: 'El cliente',
  1: 'Mediante financiamiento',
  2: 'Otra persona distinta',
};

export namespace WhoPaysType {
  export function items() {
    var items = Object.keys(WhoPaysType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: whoPaysTypeValues[index], value: index };
      });
    return items.filter((x) => x.key != undefined);
  }
}
